var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReason2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 292,
    viewBox: "0 0 292 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 146,
    r: 146,
    fill: "#E4E1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.4241 90.7052H216.851C220.894 90.7052 224.205 93.9785 224.205 98.0364V197.967C224.205 201.998 220.921 205.298 216.851 205.298H77.3969C73.3536 205.298 70.043 202.025 70.043 197.967V98.0364C70.043 94.0056 73.3265 90.7052 77.3969 90.7052H77.4241Z",
    fill: "#7452C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.852 206.651H77.3983C72.5951 206.651 68.6875 202.756 68.6875 197.967V98.0093C68.6875 93.2211 72.5951 89.3256 77.3983 89.3256H216.825C221.628 89.3256 225.536 93.2211 225.536 98.0093V197.967C225.536 202.756 221.628 206.651 216.825 206.651H216.852ZM77.3983 92.0578C74.0876 92.0578 71.4011 94.736 71.4011 98.0364V197.967C71.4011 201.268 74.0876 203.946 77.3983 203.946H216.825C220.136 203.946 222.822 201.268 222.822 197.967V98.0093C222.822 94.709 220.136 92.0308 216.825 92.0308H77.3983V92.0578Z",
    fill: "#3C2163"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.994 126.941L247.43 132.488L252.994 138.036L258.559 132.488L252.994 126.941Z",
    fill: "#6AD1EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M252.997 139.507L245.996 132.528L252.997 125.549L259.998 132.528L252.997 139.507ZM248.873 132.528L252.997 136.64L257.122 132.528L252.997 128.416L248.873 132.528Z",
    fill: "#705699"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.68 67.6026H184.533C183.773 67.6026 183.176 67.0075 183.176 66.25C183.176 65.4925 183.773 64.8974 184.533 64.8974H187.68C188.44 64.8974 189.037 65.4925 189.037 66.25C189.037 67.0075 188.44 67.6026 187.68 67.6026Z",
    fill: "#F58B93"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.392 67.6026H193.271C192.511 67.6026 191.914 67.0075 191.914 66.25C191.914 65.4925 192.511 64.8974 193.271 64.8974H196.392C197.151 64.8974 197.748 65.4925 197.748 66.25C197.748 67.0075 197.151 67.6026 196.392 67.6026Z",
    fill: "#F58B93"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.474 64.8433C189.714 64.8433 189.117 64.2481 189.117 63.4907V60.3526C189.117 59.5951 189.714 59 190.474 59C191.234 59 191.831 59.5951 191.831 60.3526V63.4907C191.831 64.2481 191.234 64.8433 190.474 64.8433Z",
    fill: "#F58B93"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.474 73.5271C189.714 73.5271 189.117 72.9319 189.117 72.1744V69.0364C189.117 68.2789 189.714 67.6838 190.474 67.6838C191.234 67.6838 191.831 68.2789 191.831 69.0364V72.1744C191.831 72.9319 191.234 73.5271 190.474 73.5271Z",
    fill: "#F58B93"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5046 156.659H33.3568C32.597 156.659 32 156.063 32 155.306C32 154.549 32.597 153.953 33.3568 153.953H36.5046C37.2645 153.953 37.8615 154.549 37.8615 155.306C37.8615 156.063 37.2645 156.659 36.5046 156.659Z",
    fill: "#6AD1EA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2156 156.659H42.0678C41.3079 156.659 40.7109 156.063 40.7109 155.306C40.7109 154.549 41.3079 153.953 42.0678 153.953H45.2156C45.9754 153.953 46.5724 154.549 46.5724 155.306C46.5724 156.063 45.9754 156.659 45.2156 156.659Z",
    fill: "#6AD1EA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2709 153.899C38.5111 153.899 37.9141 153.304 37.9141 152.547V149.409C37.9141 148.651 38.5111 148.056 39.2709 148.056C40.0307 148.056 40.6277 148.651 40.6277 149.409V152.547C40.6277 153.304 40.0307 153.899 39.2709 153.899Z",
    fill: "#6AD1EA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2709 162.583C38.5111 162.583 37.9141 161.988 37.9141 161.23V158.092C37.9141 157.335 38.5111 156.74 39.2709 156.74C40.0307 156.74 40.6277 157.335 40.6277 158.092V161.23C40.6277 161.988 40.0307 162.583 39.2709 162.583Z",
    fill: "#6AD1EA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M165.486 224.262H123.207L127.63 205.299H160.574L165.486 224.262Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167.248 225.615H121.496L126.543 203.946H161.604L167.221 225.615H167.248ZM124.915 222.91H163.747L159.514 206.651H128.687L124.888 222.91H124.915Z",
    fill: "#3C2163"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M173.785 224.262H113.434V231.647H173.785V224.262Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M175.143 233H112.078V222.91H175.143V233ZM114.792 230.295H172.429V225.615H114.792V230.295Z",
    fill: "#3C2163"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4035 60.7167L90.8359 66.2611L96.3976 71.8114L101.965 66.2669L96.4035 60.7167Z",
    fill: "#F7D979"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3939 72.8237C96.1225 72.8237 95.8783 72.7155 95.6612 72.5261L90.0983 66.9804C89.6912 66.5746 89.6912 65.9524 90.0983 65.5466L95.6612 60.0009C96.0683 59.5951 96.6924 59.5951 97.0994 60.0009L102.662 65.5466C103.069 65.9524 103.069 66.5746 102.662 66.9804L97.0994 72.5261C96.9095 72.7155 96.6381 72.8237 96.3668 72.8237H96.3939ZM92.2692 66.25L96.3939 70.3619L100.519 66.25L96.3939 62.1381L92.2692 66.25Z",
    fill: "#705699"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2227 183.576V197.967C61.2227 201.998 64.5062 205.299 68.5766 205.299H208.003C212.074 205.299 215.357 202.025 215.357 197.967V183.576H61.2227Z",
    fill: "#C3A1F3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M208.005 206.651H68.578C63.7748 206.651 59.8672 202.756 59.8672 197.967V182.223H216.716V197.967C216.716 202.756 212.808 206.651 208.005 206.651ZM62.5808 184.928V197.967C62.5808 201.268 65.2673 203.946 68.578 203.946H208.005C211.315 203.946 214.002 201.268 214.002 197.967V184.928H62.5808Z",
    fill: "#3C2163"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M215.357 98.0093C215.357 93.9515 212.074 90.6782 208.003 90.6782H68.5766C64.5062 90.6782 61.2227 93.9515 61.2227 98.0093V183.549H215.357V98.0093Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M216.716 184.928H59.8672V98.0093C59.8672 93.2211 63.7748 89.3256 68.578 89.3256H208.005C212.808 89.3256 216.716 93.2211 216.716 98.0093V184.928ZM62.5808 182.223H214.002V98.0093C214.002 94.709 211.315 92.0308 208.005 92.0308H68.578C65.2673 92.0308 62.5808 94.709 62.5808 98.0093V182.196V182.223Z",
    fill: "#3C2163"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M142.798 194.099C142.798 196.588 140.79 198.59 138.294 198.59C135.797 198.59 133.789 196.588 133.789 194.099C133.789 191.61 135.797 189.608 138.294 189.608C140.79 189.608 142.798 191.61 142.798 194.099Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M138.295 199.942C135.066 199.942 132.434 197.318 132.434 194.099C132.434 190.88 135.066 188.256 138.295 188.256C141.524 188.256 144.157 190.88 144.157 194.099C144.157 197.318 141.524 199.942 138.295 199.942ZM138.295 190.961C136.558 190.961 135.147 192.368 135.147 194.099C135.147 195.83 136.558 197.237 138.295 197.237C140.032 197.237 141.443 195.83 141.443 194.099C141.443 192.368 140.032 190.961 138.295 190.961Z",
    fill: "#3C2163"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M198.157 207.598H186.516V231.756H198.157V207.598Z",
    fill: "#7452C6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M199.188 232.757H185.512V206.57H199.188V232.757ZM187.547 230.728H197.153V208.599H187.547V230.728Z",
    fill: "#3C2163"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M194.032 207.598H182.391V231.756H194.032V207.598Z",
    fill: "#8FDAE2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M195.063 232.757H181.387V206.57H195.063V232.757ZM183.422 230.728H193.028V208.599H183.422V230.728Z",
    fill: "#3C2163"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M220.407 194.802H208.766V231.756H220.407V194.802Z",
    fill: "#7452C6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M221.438 232.757H207.762V193.774H221.438V232.757ZM209.797 230.728H219.403V195.803H209.797V230.728Z",
    fill: "#3C2163"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M216.313 194.802H204.645V231.756H216.313V194.802Z",
    fill: "#F58B93"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M217.317 232.757H203.613V193.774H217.317V232.757ZM205.649 230.728H215.282V195.803H205.649V230.728Z",
    fill: "#3C2163"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M243.364 183.954H231.723V231.729H243.364V183.954Z",
    fill: "#7452C6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M244.395 232.757H230.719V182.953H244.395V232.757ZM232.754 230.728H242.36V184.982H232.754V230.728Z",
    fill: "#3C2163"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M239.27 183.954H227.602V231.729H239.27V183.954Z",
    fill: "#8FDAE2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M240.274 232.757H226.57V182.953H240.274V232.757ZM228.606 230.728H238.239V184.982H228.606V230.728Z",
    fill: "#3C2163"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M238.137 162.432L181.648 196.135L183.042 198.456L239.531 164.753L238.137 162.432Z",
    fill: "#3C2163"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M238.533 169.806L235.955 168.913L237.584 164.179L232.292 164.477L232.156 161.771L241.464 161.285L238.533 169.806Z",
    fill: "#3C2163"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M114.25 145.675H86.082V163.124H114.25V145.675Z",
    fill: "#8FDAE2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M152.593 145.675H124.426V163.124H152.593V145.675Z",
    fill: "#F58B93"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M190.504 145.675H162.336V163.124H190.504V145.675Z",
    fill: "#8FDAE2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M107.386 113.7H87.4141V129.688H107.386V113.7Z",
    fill: "#F7D979"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M186.272 113.808H119.164V116.513H186.272V113.808Z",
    fill: "#3C2163"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M158.132 120.977H119.164V123.682H158.132V120.977Z",
    fill: "#3C2163"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M147.684 128.362H119.164V131.067H147.684V128.362Z",
    fill: "#3C2163"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M170.828 128.362H154.492V131.067H170.828V128.362Z",
    fill: "#3C2163"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M175.768 120.977H165.918V123.682H175.768V120.977Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M201.305 90.7052V173.242H61.2266V183.576H201.305H215.361V173.242V90.7052H201.305Z",
    fill: "#EAEAF9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReason2);
export default __webpack_public_path__ + "static/media/reason2.b5917c125749d58ccf1b96b0840b78be.svg";
export { ForwardRef as ReactComponent };